import React, { forwardRef } from "react";
import ViewList from "@material-ui/icons/ViewList";
import ViewCards from "@material-ui/icons/ViewModule";
import SearchIcon from "@material-ui/icons/Search";
import Select from "react-select";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Tooltip,
} from "@mui/material";
import { Form } from "react-bootstrap";
import {
  CardsWrapper,
  ContentFilters,
  customStyles,
  ResetButton,
  SearchField,
  TableViewButton,
} from "./FiltersByCases.styled";

const FiltersByCases = forwardRef((props, ref) => {
  return (
    <CardsWrapper className="pt-3 pb-2">
      <Box
        sx={{
          minWidth: 555,
          maxWidth: 556,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box sx={{ minWidth: 185, maxWidth: 186, margin: "0 0.5em 0 2em" }}>
          <FormControl variant="standard" fullWidth style={{ zIndex: 2 }}>
            <InputLabel id="filter-status-select-label">
              Filter by Status
            </InputLabel>
            <Select
              styles={customStyles}
              placeholder="Filter by Status"
              ref={ref?.rStatus}
              options={props.myListStatuses}
              onChange={props.handleChangeStatus}
            />
          </FormControl>
        </Box>
        <Box sx={{ minWidth: 185, maxWidth: 186, margin: "0 0.5em" }}>
          <FormControl variant="standard" fullWidth>
            <Form.Control
              type="date"
              required={false}
              ref={ref?.rDateValue}
              onChange={props.handleChangeDate}
            />
          </FormControl>
        </Box>
        <Box sx={{ minWidth: 185, maxWidth: 186, margin: "0 0.5em" }}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={props.activeHightPriority}
                  onClick={() => {
                    props.setActiveHightPriority(!props.activeHightPriority);
                  }}
                />
              }
              label="High Priority"
            />
          </FormGroup>
        </Box>
      </Box>
      <Box
        sx={{
          minWidth: 370,
          maxWidth: 371,
          display: "flex",
          alignItems: "center",
          margin: "0em 0.5em 0em 0em",
        }}
      >
        <Box sx={{ margin: "0 0.5em" }}>
          <ContentFilters>
            <SearchField>
              <SearchIcon />
              <Form.Control
                type="text"
                placeholder="Search"
                onChange={props.handleSearch}
                ref={ref?.rSearch}
              />
            </SearchField>
          </ContentFilters>
        </Box>
        <Box sx={{ margin: "0 0.5em" }}>
          <ContentFilters>
            <ResetButton onClick={() => props.resetFilters()}>
              Reset
            </ResetButton>
          </ContentFilters>
        </Box>
        <Box>
          <div className="table-action">
            <Tooltip title="View List">
              <TableViewButton
                iconColor={props.showCards}
                onClick={() => props.setShowCards(false)}
                className="MuiButtonBase-root MuiIconButton-root"
              >
                <span
                  style={{ width: "fit-content" }}
                  className="MuiIconButton-label"
                >
                  <ViewList className="list-view" />
                </span>
              </TableViewButton>
            </Tooltip>
            <Tooltip title="View Cards">
              <TableViewButton
                iconColor={props.showCards}
                onClick={() => props.setShowCards(true)}
                style={{ borderLeft: "none" }}
                className="MuiButtonBase-root MuiIconButton-root"
              >
                <span
                  style={{ width: "fit-content" }}
                  className="MuiIconButton-label"
                >
                  <ViewCards className="card-view" />
                </span>
              </TableViewButton>
            </Tooltip>
          </div>
        </Box>
      </Box>
    </CardsWrapper>
  );
});

export default FiltersByCases;
